// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Prefooter_wrapper__scFBH {
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 50px;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd {
  margin-top: 60px;
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS {
  max-width: 550px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 20px;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_title__PQ0u2 {
  font-family: "Open Sans Bold";
  font-weight: 800;
  font-size: 56px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #faf9f8;
  white-space: nowrap;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_desc_group__9AUwe {
  display: flex;
  flex-direction: column;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_desc_group__9AUwe .Prefooter_desc__iZQtf {
  font-family: "Open Sans SemiBold";
  font-weight: 700;
  font-size: 20px;
  color: #dad6ce;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_btn__TZ84N {
  font-weight: 500;
  font-style: normal;
  border-radius: 12px;
  width: 104px;
  height: 42px;
  background: #f2f740;
  margin-top: 20px;
  line-height: 130%;
  color: #292621;
  font-size: 16px;
  cursor: pointer;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_btn__TZ84N:hover {
  background-color: #f5f966;
}
.Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_btn__TZ84N:active {
  background-color: #e6eb3d;
}

@media (max-width: 1000px) {
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS {
    margin-left: 0px;
  }
}
@media (max-width: 679px) {
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd {
    display: flex;
    flex-direction: column;
  }
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group_img__ssGc6 {
    width: 100%;
    margin-top: 25px;
  }
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS {
    align-items: center;
  }
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_title__PQ0u2 {
    font-size: 32px;
  }
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_desc_group__9AUwe {
    text-align: center;
  }
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_desc_group__9AUwe .Prefooter_desc__iZQtf {
    font-size: 16px;
  }
  .Prefooter_wrapper__scFBH .Prefooter_section__t9IYd .Prefooter_group__pw9sS .Prefooter_btn__TZ84N {
    width: 104px;
    height: 42px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/components/Prefooter/Prefooter.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EAEA,4BAAA;EACA,sBAAA;EACA,gBAAA;AAFF;AAGE;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AADN;AAGM;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AADR;AAGM;EACE,aAAA;EACA,sBAAA;AADR;AAGQ;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADV;AAKM;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAHR;AAIQ;EACE,yBAAA;AAFV;AAKQ;EACE,yBAAA;AAHV;;AAUA;EAKM;IACE,gBAAA;EAXN;AACF;AAeA;EAOI;IACE,aAAA;IACA,sBAAA;EAnBJ;EAoBI;IACE,WAAA;IACA,gBAAA;EAlBN;EAoBI;IACE,mBAAA;EAlBN;EAmBM;IACE,eAAA;EAjBR;EAmBM;IACE,kBAAA;EAjBR;EAkBQ;IACE,eAAA;EAhBV;EAmBM;IACE,YAAA;IACA,YAAA;EAjBR;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.wrapper {\n  position: relative;\n  // background-image: url(\"../../assets/images/prefooter_bg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin-top: 50px;\n  .section {\n    margin-top: 60px;\n    width: 85%;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .group {\n      max-width: 550px;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: baseline;\n      gap: 20px;\n  \n      .title {\n        font-family: \"Open Sans Bold\";\n        font-weight: 800;\n        font-size: 56px;\n        letter-spacing: 0.02em;\n        text-align: center;\n        color: #faf9f8;\n        white-space: nowrap;\n      }\n      .desc_group {\n        display: flex;\n        flex-direction: column;\n\n        .desc {\n          font-family: \"Open Sans SemiBold\";\n          font-weight: 700;\n          font-size: 20px;\n          color: #dad6ce;\n        }\n      }\n\n      .btn {\n        font-weight: 500;\n        font-style: normal;\n        border-radius: 12px;\n        width: 104px;\n        height: 42px;\n        background: #f2f740;\n        margin-top: 20px;\n        line-height: 130%;\n        color: #292621;\n        font-size: 16px;\n        cursor: pointer;\n        &:hover {\n          background-color: #f5f966;\n        }\n\n        &:active {\n          background-color: #e6eb3d;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1000px) {\n  .wrapper {\n    .section {\n      .group_img {\n      }\n      .group {\n        margin-left: 0px;\n      }\n    }\n  }\n}\n@media (max-width: 679px) {\n  .wrapper {\n    // background: linear-gradient(\n    //   180deg,\n    //   rgba(97, 0, 255, 0) 0%,\n    //   rgba(97, 0, 255, 0.3) 100%\n    // );\n    .section {\n      display: flex;\n      flex-direction: column;\n      .group_img {\n        width: 100%;\n        margin-top: 25px;\n      }\n      .group {\n        align-items: center;\n        .title {\n          font-size: 32px;\n        }\n        .desc_group {\n          text-align: center;\n          .desc {\n            font-size: 16px;\n          }\n        }\n        .btn {\n          width: 104px;\n          height: 42px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Prefooter_wrapper__scFBH`,
	"section": `Prefooter_section__t9IYd`,
	"group": `Prefooter_group__pw9sS`,
	"title": `Prefooter_title__PQ0u2`,
	"desc_group": `Prefooter_desc_group__9AUwe`,
	"desc": `Prefooter_desc__iZQtf`,
	"btn": `Prefooter_btn__TZ84N`,
	"group_img": `Prefooter_group_img__ssGc6`
};
export default ___CSS_LOADER_EXPORT___;
